import { computed } from '@preact/signals'
import { navigate } from 'wouter-preact/use-browser-location'

import { Button, LoadingIcon, Select, TextLink, Typography } from 'components'
import { AuthState, updateAuthState } from 'state'

import {
	onboardingQuestionsState,
	isOnboardLoadingState,
	onboardingAnswersState,
	selectOnboardingAnswers,
	closeOnboardProcess,
	completeOnboardProcess
} from './state'

const isButtonDisabled = computed(
	() =>
		onboardingQuestionsState.value.length === 0 ||
		isOnboardLoadingState.value ||
		Object.keys(onboardingAnswersState.value).length !==
			onboardingQuestionsState.value.length
)

const OnBoardingQuestions = () => {
	if (
		isOnboardLoadingState.value &&
		Object.keys(onboardingAnswersState.value).length === 0
	) {
		return (
			<div class='flex h-60 items-center justify-center'>
				<LoadingIcon class='h-10 w-10 text-product' />
			</div>
		)
	}

	return (
		<>
			{onboardingQuestionsState.value.map(
				question =>
					question.active && (
						<div key={question.id}>
							<Select
								aria-label={question.id.toString()}
								description={question.content}
								id={question.id.toString()}
								label={question.title}
								onChange={selectOnboardingAnswers}
								options={question.possibleAnswers.map(answer => ({
									label: answer.content,
									value: answer.id
								}))}
								value={onboardingAnswersState.value[question.title]}
							/>
						</div>
					)
			)}
		</>
	)
}

const OnboardingForm = () => {
	const onSkip = () => {
		closeOnboardProcess()

		updateAuthState(() => AuthState.authenticated)
		navigate('/', { replace: true })
	}

	const onComplete = async (e: Event) => {
		e.preventDefault()

		await completeOnboardProcess()

		updateAuthState(() => AuthState.authenticated)
		navigate('/', { replace: true })
	}

	return (
		<div class='w-[30rem] rounded-lg border border-black-600 p-8 pb-12'>
			<Typography
				class='text-center'
				color='text-product'
				text='Welcome to Código'
				variant='h2'
			/>
			<div class='mb-8 mt-6 text-center'>
				<Typography
					color='text-white'
					text='Before you start coding, tell us a bit about yourself'
					variant='text2'
				/>
				<Typography
					color='text-white'
					text='so we can personalize your experience.'
					variant='text2'
				/>
			</div>

			<form class='w-full space-y-7' onSubmit={onComplete}>
				<OnBoardingQuestions />

				<div class='flex justify-between'>
					<TextLink
						ariaLabel='Close modal'
						onClick={onSkip}
						size='small'
						text='Skip'
						variant='secondary'
					/>

					<Button
						disabled={isButtonDisabled.value}
						isLoading={isOnboardLoadingState.value}
						onClick={onComplete}
						text='Get Started'
						type='submit'
					/>
				</div>
			</form>
		</div>
	)
}

export { OnboardingForm }
